import React from 'react';
import {Collapse} from 'reactstrap';
import ReactMarkdown from 'react-markdown';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faMinus} from '@fortawesome/pro-solid-svg-icons/faMinus';
import {faPlus} from '@fortawesome/pro-solid-svg-icons/faPlus';
import classNames from 'classnames';

import './FaqListCL.module.scss';

export default function FaqList({faqlist, slice = 0, ...props}) {
  const [activeCards, setActiveCards] = React.useState([]);
  const onClick = React.useCallback(
    (key) => () => setActiveCards((state) => (state.includes(key) ? state.filter((e) => e !== key) : [...state, key])),
    []
  );
  return faqlist.slice(slice).map((faq, index) => {
    return (
      <div className={classNames('faq-card', `faq-card`, `box-shadow-black-25`, `rounded`)} key={index}>
        <div
          className={classNames(
            'faq-card-header',
            `faq-card-header`,
            activeCards.includes(index) ? 'faq-card-header-open' : 'faq-card-header-closed',
            `d-flex`,
            `align-items-center`,
            `justify-content-between`,
            activeCards.includes(index) ? `rounded-top` : `rounded`
          )}
          onClick={onClick(index)}
        >
          <div className="faq-card-header-text">
            <ReactMarkdown className={classNames('faq-card-header-title')} source={faq.question || 'faq question'} />
          </div>
          <div className={classNames('faq-card-header-icon')}>
            <FontAwesomeIcon
              className={classNames('faq-card-icon')}
              icon={activeCards.includes(index) ? faMinus : faPlus}
            />
          </div>
        </div>
        <Collapse isOpen={activeCards.includes(index)}>
          <div className={classNames('faq-card-content')}>
            <ReactMarkdown source={faq.answer || 'faq answer'} />
          </div>
        </Collapse>
      </div>
    );
  });
}
